import React, { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "@/context/AdminAuthContext";
import { Card, PageTitle, Btn, Field, Input, Textarea } from "@/admin/ui";

const SLUGS = [["privacy-policy", "Privacy Policy"], ["terms", "Terms & Conditions"], ["shipping-returns", "Shipping & Returns"]];

export default function Pages() {
  const [pages, setPages] = useState({});
  const [slug, setSlug] = useState(SLUGS[0][0]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/pages").then(({ data }) => setPages(Object.fromEntries(data.map((p) => [p.id, p])))).catch(() => {});
  }, []);

  const page = pages[slug] || { title: SLUGS.find(([s]) => s === slug)[1], content: "" };
  const setField = (k) => (e) => setPages((p) => ({ ...p, [slug]: { ...page, [k]: e.target.value } }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminApi.put(`/admin/pages/${slug}`, { title: page.title, content: page.content });
      setPages((p) => ({ ...p, [slug]: data }));
      toast.success("Page saved");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-pages-page">
      <PageTitle title="Legal Pages" sub="Edit your policies. Use '## ' for headings and '- ' for bullet points." />
      <div className="flex flex-wrap gap-2 mb-6">
        {SLUGS.map(([s, label]) => (
          <button key={s} data-testid={`page-tab-${s}`} onClick={() => setSlug(s)} className={`text-[11px] font-bold uppercase tracking-[0.14em] px-4 py-2.5 rounded-full border transition-colors ${slug === s ? "bg-forest text-cream border-forest" : "border-forest/20 text-forest hover:bg-forest/5"}`}>{label}</button>
        ))}
      </div>
      <Card className="p-6 sm:p-8">
        <form onSubmit={save} className="space-y-4">
          <Field label="Page title"><Input data-testid="page-title-input" value={page.title} onChange={setField("title")} required /></Field>
          <Field label="Content"><Textarea data-testid="page-content-input" rows={22} value={page.content} onChange={setField("content")} className="font-mono !text-xs leading-relaxed" /></Field>
          <div className="flex items-center justify-between">
            <a href={`/legal/${slug}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-xs text-mutedgreen hover:text-forest"><ExternalLink size={13} /> View on website</a>
            <Btn type="submit" busy={busy} data-testid="page-save-button">Save page</Btn>
          </div>
        </form>
      </Card>
    </div>
  );
}
